const firstSubmenu = document.querySelector('.nav-extended .menu-item > ul');
if (firstSubmenu) {
  firstSubmenu.classList.add('is-open');
  firstSubmenu.closest('.menu-item').classList.add('submenu-open');
}

document.querySelectorAll('.nav-extended .menu-item').forEach(function(item) {
  const submenu = item.querySelector(':scope > ul');
  if (!submenu) return;

  const link = item.querySelector(':scope > a');
  if (!link) return;

  link.addEventListener('click', function(e) {
    e.preventDefault();
    const isOpen = submenu.classList.contains('is-open');

    // Close all other open submenus
    document.querySelectorAll('.nav-extended .sub-menu.is-open').forEach(function(open) {
      open.classList.remove('is-open');
      open.closest('.menu-item').classList.remove('submenu-open');
    });

    if (!isOpen) {
      submenu.classList.add('is-open');
      item.classList.add('submenu-open');
    }
  });
});


